import { SelectTenant } from '@xeetr/types/models'
import { Check, LogOut } from 'lucide-react'
import { useContext, useState } from 'react'

import { ActiveUserContext } from '../../../context/common/Context'
import { useActiveTenant } from '../../../hooks/common/useActiveTenant'
import { useAuth } from '../../../hooks/useAuth'


import { Button } from '@/components/ui/button'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'


const UserInfo = () => {
  const defaultLogo = '/xeetr-logo-dark.png'

  const { user } = useContext(ActiveUserContext)
  const { tenant, setTenantId } = useActiveTenant()

  const { logout } = useAuth()
  const [isOpen, setIsOpen] = useState(false)

  const tenantTemplate = (item: SelectTenant) => {
    const isSelected = tenant?.tenantId === item.tenantId
    return (
      <div className="grid w-full grid-cols-[2rem_auto_1rem] flex-row items-center gap-2">
        <div className="flex h-8 w-8 place-content-center items-center overflow-clip rounded-lg bg-white">
          <img
            alt="logo"
            src={item?.tenantLogoUrl ?? defaultLogo}
            className="my-auto max-w-full object-contain"
          />
        </div>
        <div className="break-normal">{item.tenantName}</div>
        {isSelected && <Check className="h-4 w-4" />}
      </div>
    )
  }

  return (
    <div className="align-items-center ml-auto flex">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <div className="my-auto flex flex-none cursor-pointer flex-row text-white hover:underline hover:decoration-2 hover:underline-offset-2">
            <div className="flex h-12 w-12 place-content-center items-center overflow-clip rounded-2xl bg-white text-black">
              <img
                alt="logo"
                src={tenant?.tenantLogoUrl ?? defaultLogo}
                className="m-auto max-w-full object-cover"
              />
            </div>
            <div className="mx-3 my-auto hidden flex-col text-white md:flex">
              <span className="font-medium">{user?.name}</span>
              <span className="text-xs">{tenant?.tenantName}</span>
            </div>
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-[300px] p-0" align="end">
          <div>
            {user?.tenants && user?.tenants.length > 1 && (
              <Command>
                {user.tenants.length > 3 && <CommandInput placeholder="Suche nach Unternehmen" />}
                <CommandList>
                  <CommandEmpty>Kein Unternehmen gefunden.</CommandEmpty>
                  <CommandGroup>
                    {user.tenants.map((item) => (
                      <CommandItem
                        key={item.tenantId}
                        value={item.tenantName}
                        onSelect={() => {
                          setTenantId(item.tenantId)
                          setIsOpen(false)
                        }}
                      >
                        {tenantTemplate(item)}
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </CommandList>
              </Command>
            )}
            <Button
              variant="link"
              className="w-full"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            >
              <LogOut className="mr-2 h-4 w-4" />
              Abmelden
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default UserInfo
